export default {"src":"/_next/static/media/EmptyCart.1944d4c4.svg","height":212,"width":213,"blurWidth":0,"blurHeight":0};